import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Covers both authenticated users and guest sessions.
// Add fields as the backend response evolves.
export interface UserInfo {
  user_id?: string;
  guest_id?: string;
  username?: string;
  email?: string;
  phone?: string;
  [key: string]: unknown; // allow extra backend fields without losing type safety
}

interface AuthState {
  userInfo: UserInfo | null;
  roles: string[] | null;
}

const initialState: AuthState = {
  userInfo: null,
  roles: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUserInfo: (state, action: PayloadAction<UserInfo>) => {
      state.userInfo = action.payload;
    },
    setUserRoles: (state, action: PayloadAction<string[]>) => {
      state.roles = action.payload;
    },
    clearUserInfo: (state) => {
      state.userInfo = null;
      state.roles = null;
    },
  },
});

export const { setUserInfo, setUserRoles, clearUserInfo } = authSlice.actions;
export default authSlice.reducer;
